"use client";

import React from "react";
import { motion } from "framer-motion";
import { CircleCheck as CheckCircle2 } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const serviceDetailsData = [{
  id: "item-1",
  title: "Shower Updates and Conversions",
  content: "Shower updates can include new tile surrounds, shower fixtures, glass doors, storage niches, built-in seating, and tub-to-shower conversions. These updates can help improve comfort, accessibility, and the overall look of your bathroom in Lakeland, FL."
}, {
  id: "item-2",
  title: "Tub Replacements and Installations",
  content: "Tub replacement projects can include removing an old bathtub, updating a shower-tub combination, or reviewing options for a new tub that fits your bathroom layout, comfort needs, and project goals."
}, {
  id: "item-3",
  title: "Tile and Flooring Solutions",
  content: "Bathroom tile and flooring updates can include floor tile, wall tile, shower tile, waterproof flooring, and updated finishes. Common options may include ceramic, porcelain, natural stone, or other bathroom-friendly materials."
}, {
  id: "item-4",
  title: "Vanities, Cabinets, and Sinks",
  content: "Vanity and sink updates can improve storage, counter space, and daily use. Bathroom remodel projects may include single vanities, double vanities, sinks, countertops, cabinets, mirrors, and hardware updates."
}, {
  id: "item-5",
  title: "Faucets, Mirrors, and Lighting",
  content: "Fixture updates can include faucets, mirrors, lighting, towel bars, cabinet hardware, and other finishing details. These smaller updates can help refresh the look and function of your bathroom."
}, {
  id: "item-6",
  title: "Storage and Layout Improvements",
  content: "Layout and storage updates can help make a bathroom more useful and comfortable. Projects may include changing vanity placement, improving storage, adding shelving, updating lighting, or reviewing ways to make better use of the space."
}, {
  id: "item-7",
  title: "Accessibility and Comfort Updates",
  content: "Accessibility and comfort updates can include grab bars, non-slip flooring, wider entry areas, walk-in showers, lower thresholds, handheld showerheads, and other updates that make the bathroom easier to use."
}];
export default function ServiceDetails() {
  return <section id="serviceexpansiondetails" className="py-16 md:py-24 bg-primary">
      <div className="container mx-auto max-w-4xl px-4 md:px-6">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: "-100px"
      }} transition={{
        duration: 0.6
      }} className="mb-12 text-center">
          <h2 className="font-default text-3xl font-bold tracking-tight md:text-4xl text-primary-foreground">
            What Bathroom Remodel Services Can Include
          </h2>
          <p className="mx-auto mt-4 max-w-2xl font-sans text-lg text-primary-foreground">
            Explore the specific updates and improvements available for your
            bathroom remodel project in Lakeland, FL and nearby Polk County
            areas.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: "-100px"
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="rounded-xl border border-border bg-card p-4 shadow-sm md:p-8">
          <Accordion type="single" collapsible className="w-full">
            {serviceDetailsData.map((item, i) => <AccordionItem data-index={i} key={item.id} value={item.id}>
                <AccordionTrigger className="font-default text-base font-semibold text-foreground hover:text-primary md:text-lg">
                  <span className="flex items-center gap-3 text-left">
                    <CheckCircle2 className="size-5 shrink-0 text-primary" />
                    {item.title}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pl-8 font-sans text-base text-muted-foreground md:text-base">
                  {item.content}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: "-50px"
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-12 flex justify-center !bg-transparent">
          <Button asChild size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive shadow-xs hover:bg-primary/90 h-10 rounded-md has-[>svg]:px-4 px-8 text-base bg-primary-foreground text-primary">
            <Link to="/contact">
              Request a Free Quote
            </Link>
          </Button>
        </motion.div>
      </div>
    </section>;
}